export const getUserDomain = () => {
    const userDomain = window.location.host.split('.')[0];

    if (userDomain.includes('localhost:300')) {
        return 'roy';
    }

    return userDomain;
}
